import { openPopup } from './popup/popup';
import { showAlert } from './showAlert/showAlert';
import {
  showConfirm,
  showConfirmWithCheckbox,
  showConfirmWithCloseBtn,
} from './showConfirm/showConfirm';
import { showToast } from './showToast/showToast';

export default {
  showConfirm,
  showConfirmWithCheckbox,
  showConfirmWithCloseBtn,
  openPopup,
  showAlert,
  showToast,
};
